import {decorate, observable} from 'mobx';
import {faPuzzlePiece} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export class Ingredient extends BaseModel {
  static faIcon = faPuzzlePiece;

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.unitOfMeasure = rootStore.unitOfMeasurementStore.getById(this.unitOfMeasureId);
    this.material = rootStore.materialStore.getById(this.materialId);
    this.batch = rootStore.batchStore.getById(this.batchId);
    if (this.stock && this.stock.length) {
      this.stock.forEach((stockEntry) => {
        stockEntry.batch = this.batch;
      });
    }
  }
}

decorate(Ingredient, {
  no: observable,
  type: observable,
  materialId: observable,
  material: observable,
  batchId: observable,
  batch: observable,
  expiryDate: observable,
  locked: observable,
  amount: observable,
  unitOfMeasureId: observable,
  unitOfMeasure: observable,
  isSingleUse: observable,
  stock: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  expireDate: observable,
});

export const IngredientType = {
  code128Ingredient: 'CODE_128_INGREDIENT',
  code128PurchaseNo: 'CODE_128_PURCHASE_NO',
  insoftSingleUse: 'INSOFT_SINGLE_USE',
  insoftMultiUse: 'INSOFT_MULTI_USE',
  sscc: 'SSCC',
};
